export class StatusModel {
  id: number;
  name: string;
  amount: number;
  searchAmount: number;
  statusAmount: number;
}
